export function operacaoAbastecimentosInRequest(params = {}) {
  return {
    type: '@operacaoabastecimento/OPERACAOABASTECIMENTOS_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoAbastecimento(idoperacaoabastecimento) {
  return {
    type: '@operacaoabastecimento/FIND_OPERACAOABASTECIMENTO',
    payload: { idoperacaoabastecimento },
  };
}

export function failedRequest() {
  return {
    type: '@operacaoabastecimento/FAILED_REQUEST',
  };
}

export function setLoading() {
  return {
    type: '@operacaoabastecimento/SET_LOADING',
  };
}

export function deleteOperacaoAbastecimento(
  idoperacaoabastecimento,
  params,
  query = {}
) {
  return {
    type: '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO',
    payload: { idoperacaoabastecimento, params, query },
  };
}

export function updateOperacaoAbastecimento(operacaoabastecimentos, params) {
  return {
    type: '@operacaoabastecimento/UPDATE_OPERACAOABASTECIMENTO',
    payload: { operacaoabastecimentos, params },
  };
}

export function storeOperacaoAbastecimento(operacaoabastecimento, params) {
  return {
    type: '@operacaoabastecimento/STORE_OPERACAOABASTECIMENTO',
    payload: { operacaoabastecimento, params },
  };
}

export function successInRequest(
  operacaoabastecimentos,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaoabastecimento/SUCCESS_IN_REQUEST',
    payload: { operacaoabastecimentos, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaoabastecimento) {
  return {
    type: '@operacaoabastecimento/SUCCESS_REQUEST',
    payload: { operacaoabastecimento },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaoabastecimento/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function successRemoveForm(params) {
  return {
    type: '@operacaoabastecimento/SUCCESS_REMOVE_FORM',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaoabastecimento/RECORD_FILTERING',
    payload: { params },
  };
}

export function deletarClienteOperacaoAbastecimento(
  operacaoabastecimentos,
  params
) {
  return {
    type: '@operacaoabastecimento/DELETE_OPERACAOABASTECIMENTO_CLIENTE',
    payload: { operacaoabastecimentos, params },
  };
}
